<template>
  <div>
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
      <b-card-code class="principal mt-2">
        <b-col
          cols="12"
          class="pr-0 pl-0 mt-2"
        >
          <b-table
            v-if="items.length>0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(acciones)="data">
              <b-link :to="{name:'permisos', params:{token:data.item.token}}">
                <font-awesome-icon icon="magnifying-glass" />
              </b-link>
            </template>
            <template #cell(nombre)="data">
              <b-link :to="{name:'editrol', params:{token:data.item.token}}">
                {{ data.value }}
              </b-link>
              <strong>
                {{ " (" + data.item.codigo + ")" }}
              </strong>
            </template>

            <template #cell(descripcion)="data">
              {{ data.value == null || data.value === "" ? "-" : data.value }}
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col
          cols="12"
          class="mb-2"
        >
          <b-pagination
            v-model="currentPage"
            v-if="items.length>0"
            :total-rows="items.length"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BImg, BCardHeader, BCardGroup, BCardTitle, BLink,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import actions from '@/assets/utils/utils'
import axios from "@/libs/axios";
import $ from 'jquery'

import { BOverlay } from 'bootstrap-vue'
import Vue from "vue";

export default {
  components: {
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    BLink,
    BOverlay,
  },
  data() {
    return {
      login_user: '',
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'acciones', label: 'Acciones', sortable: true, thClass:'text-center', thStyle: { width: '10%' }, tdClass:'text-center' },
        { key: 'nombre', label: 'Nombre', sortable: true, thClass: 'text-center', thStyle: { width: '20%' } },
        { key: 'descripcion', label: 'Descripción', sortable: true, thClass: 'text-center', thStyle: { width: '70%' } },
      ],
      items: [],
      mostrarLoader: false,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    $('#btn-excel').remove()
    $('#btn-pdf').remove()
    $('#eliminar-viajes').remove()
    this.setToken()
  },
  mounted() {
    actions.setearTitulo('')
    // Set the initial number of items
    this.cargarRoles()
    this.totalRows = this.items.length
  },
  methods: {
    cargarRoles() {
      this.mostrarLoader = true
      axios.post('api', {
        query: `{
                    getRoles{
                        roles{
                            token,
                            codigo,
                            nombre,
                            descripcion
                        },
                        status,
                        message
                    }
                }`,
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.getRoles.status === 'success') {
            this.items = response.data.data.getRoles.roles
          }
        }
        this.mostrarLoader = false
      })
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
<style>
.principal .card-header{
    display: none !important
}
.principal .card-body{
    padding-bottom: 0 !important;
}
[dir] .table th, [dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
